<script setup lang="ts">
import PluginWidget from './PluginWidget.vue'

defineProps<{
  convexUrl: string
}>()
</script>

<template>
  <PluginWidget />
</template>
